import { motion } from "framer-motion"
import React from "react";

export default function Ani(props) {
    return (
        <motion.div>
            {props.children}
        </motion.div>
    )
}